import React from 'react';
import { useEntity, MissingAnnotationEmptyState } from '@backstage/plugin-catalog-react';
import { Routes, Route } from 'react-router-dom';
import { buildRouteRef } from '../routes.esm.js';
import { WorkflowRunDetails } from './WorkflowRunDetails/WorkflowRunDetails.esm.js';
import { WorkflowRunsCard } from './WorkflowRunsCard/WorkflowRunsCard.esm.js';
import { WorkflowRunsTable } from './WorkflowRunsTable/WorkflowRunsTable.esm.js';
import { GITHUB_ACTIONS_ANNOTATION } from './getProjectNameFromEntity.esm.js';

const isGithubActionsAvailable = (entity) => Boolean(entity.metadata.annotations?.[GITHUB_ACTIONS_ANNOTATION]);
const Router = (props) => {
  const { view = "table" } = props;
  const { entity } = useEntity();
  if (!isGithubActionsAvailable(entity)) {
    return /* @__PURE__ */ React.createElement(MissingAnnotationEmptyState, { annotation: GITHUB_ACTIONS_ANNOTATION });
  }
  const workflowRunsComponent = view === "cards" ? /* @__PURE__ */ React.createElement(WorkflowRunsCard, { entity }) : /* @__PURE__ */ React.createElement(WorkflowRunsTable, { entity });
  return /* @__PURE__ */ React.createElement(Routes, null, /* @__PURE__ */ React.createElement(Route, { path: "/", element: workflowRunsComponent }), /* @__PURE__ */ React.createElement(
    Route,
    {
      path: `${buildRouteRef.path}`,
      element: /* @__PURE__ */ React.createElement(WorkflowRunDetails, { entity })
    }
  ));
};

export { Router, isGithubActionsAvailable };
//# sourceMappingURL=Router.esm.js.map
